<template>
  <el-drawer
    title=""
    size="100%"
    :append-to-body="true"
    :with-header="false"
    :visible.sync="drawer"
    direction="rtl"
  >
    <div class="login">
      <i
        class="el-icon-close"
        @click="handleClose"
      />
      <h2>注册</h2>
      <h3>欢迎使用智能码</h3>
      <div style="margin-top:50px;margin-bottom:30px;padding: 0 27px;">
        <label
          for=""
          class="label"
        >手机号</label>
        <van-field
          v-model="loginForm.username"
          label=""
          placeholder="请输入手机号"
        />
      </div>
      <div style="margin-bottom:30px;padding: 0 27px;position: relative;">
        <label
          for=""
          class="label"
        >验证码</label>
        <van-field
          v-model="loginForm.code"
          label=""
          placeholder="请输入验证码"
        />
        <span
          v-if="!isClick"
          class="getCode"
          @click="openCaptcha"
        >获取验证码</span>
        <span
          v-else
          class="getCodes"
        >{{ time }}s</span>
      </div>
      <div style="margin-bottom:20px;padding: 0 27px;">
        <label
          for=""
          class="label"
        >密码</label>
        <van-field
          v-model="loginForm.password"
          label=""
          placeholder="请输入密码"
          type="password"
        />
      </div>
      <van-row
        type="flex"
        justify="space-between"
        class="rowBtns"
      >
        <van-col
          span="12"
          class="register"
          @click="toLogin"
        >
          已有账号，返回登录
        </van-col>
        <van-col span="6" />
      </van-row>
      <div style="text-align:center">
        <van-button
          class="loginBtn"
          type="info"
          size="large"
          @click="login"
        >
          注册
        </van-button>
      </div>
    </div>
    <Captacha
      ref="captacha"
      @submitCa="sendSms($event)"
    />
  </el-drawer>
</template>

<script>
import { register } from '@/api/login'
import { Toast } from 'vant'
import { postJsonReturn } from '@/utils/server-wrapper'
import eventBus from '@/utils/event-bus'
import Captacha from './captacha'
import { validatePassword } from "@/utils/password";

export default {
  name: 'Login',
  components: { Captacha },
  data () {
    return {
      wxIcon: require('../../../static/icon_wx.png'),
      loginForm: {
        username: '',
        password: '',
        code: ''
      },
      isClick: false,
      timer: null,
      time: 60,
      drawer: false
    }
  },
  mounted () {
    document.title = '智能码移动站 - 二维码生成器-免费二维码制作-在线二维码解决方案-在线二维码制作-二维码在线生成-二维码在线打印'
    eventBus.$on('openReg', k => {
      this.drawer = true
    })
  },
  methods: {
    validPassword (value) {
      const result = validatePassword(value)
      if (result === '' || result.length === 0) {
        return true
      } else {
        Toast.fail(result)
        return false
      }
    },
    toLogin () {
      // this.$router.push({ path: '/login', query: { 'back': '2' } })
      eventBus.$emit('openLogin')
      this.drawer = false
    },
    login () {
      // that.$router.replace({path:'/login',replace:true,query:{'back':'2'}})
      if (this.loginForm.username === '') {
        Toast.fail('请输入账号')
        return
      }
      if (this.loginForm.code === '') {
        Toast.fail('请输入验证码')
        return
      }
      if (this.loginForm.password === '') {
        Toast.fail('请输入密码')
        return
      }
      if (!this.validPassword(this.loginForm.password)) {
        return
      }

      let referer = localStorage.getItem('referrer')
      if (!referer) {
        referer = window.location.href
      }
      const r = register(this.loginForm.username, this.loginForm.code, this.loginForm.password, referer)

      r.then((res) => {
        if (res.code === 200) {
          // 成功后移除
          localStorage.removeItem('referrer')

          Toast.success('注册成功,即将跳转登录页')
          eventBus.$emit('openLogin')
          // setTimeout(function () {
          //   that.$router.replace({ path: '/login', replace: true, query: { 'back': '2' } })
          // }, 1000)
        }
      })
    },
    async sendSms (param) {
      this.loginForm.captchaCode = param.captchaVal
      this.loginForm.uuid = param.uuid
      const res = await postJsonReturn(
        '/sendSms', {
          username: this.loginForm.username,
          captchaCode: param.captchaVal,
          uuid: param.uuid
        }
      )
      if (res.code === 200) {
        this.getCaptcha()
      }
    },
    openCaptcha () {
      if (this.loginForm.username === null || this.loginForm.username === '') {
        this.$message({
          type: 'error',
          message: '手机号不能为空'
        })
      } else {
        const reg = /^1[3456789]\d{9}$/
        if (!reg.test(this.loginForm.username)) {
          this.$message({
            type: 'error',
            message: '手机号格式错误'
          })
        } else {
          this.$refs.captacha.openCaptcha()
        }
      }
    },
    getCaptcha () {
      this.isClick = true
      const _this = this
      this.timer = setInterval(function () {
        _this.time = _this.time - 1
        if (_this.time === 0) {
          clearInterval(_this.timer)
          _this.time = 60
          _this.isClick = false
        }
      }, 1000)
    },
    handleClose () {
      this.drawer = false
    }
  }
}
</script>
<style lang="scss">
.el-drawer__header {
  margin-bottom: 0px !important;
}

</style>
<style scoped lang="scss">
.login {
  height: 100%;
  width: 100%;
  background-image: url('../../../static/img_loginbg.png');
  background-size: 100%;
  background-repeat: no-repeat;
  // background: rgba(25, 25, 238, 0.842);
  box-sizing: border-box;
  padding-top: 70px;
  position: relative;

  .el-icon-close {
    font-size: 25px;
    color: #fff;
    position: absolute;
    top: 20px;
    right: 20px
  }

  h2 {
    margin-top: 0;
    margin-bottom: 15px;
    margin-left: 23px;
    padding: 0;
    font-size: 30px;
    font-weight: bold;
    color: #fff;
  }

  h3 {
    margin-top: 8px;
    margin-left: 23px;
    padding: 0;
    font-size: 20px;
    font-weight: bold;
    color: #fff;
  }

  .label {
    font-size: 18px;
    font-weight: bold;
    color: #081C35;
  }

  .loginBtn {
    margin: 31px 0 50px 0;
    width: 320px;
    height: 44px;
    background: #2578E3;
    border-radius: 5px;
  }

  .van-cell {
    border-bottom: 1px solid #F0F0F0;
    padding: 16px 0;
  }

  .rowBtns {
    padding: 0 27px;
  }

  .register {
    font-weight: 500;
    font-size: 15px;
    color: #9D9D9D;
  }

  .getCode {
    font-size: 16px;
    font-weight: 500;
    color: #2578E3;
    position: absolute;
    bottom: 18px;
    right: 40px;
  }

  .getCodes {
    font-size: 15px;
    font-weight: 500;
    color: #9D9D9D;
    position: absolute;
    bottom: 18px;
    right: 40px;
  }

  .otherLogin {
    width: 100%;
    margin-top: 80px;
    padding-bottom: 40px;
    // position: absolute;
    // bottom: 30px;
    // left: 0;

    p {
      text-align: center;
      font-size: 11px;
      font-weight: 500;
      margin-bottom: 20px;
      color: #9D9D9D;
    }

    img {
      display: block;
      margin: 0 auto;
      width: 44px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/register.vue